module.exports = __webpack_public_path__ + "img/layout-left.f4b3f089.png";